import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PerformanceReview, PerformanceReviewCreate, PerformanceReviewFilter } from '../data/performanceReview';

export function createPerformanceReviewService(client: AxiosInstance) {
  return createCrudService<PerformanceReview, PerformanceReviewCreate, PerformanceReviewFilter>(
    client,
    '/hrm/PerformanceReview',
    'id',
  );
}

export type PerformanceReviewService = CrudService<PerformanceReview, PerformanceReviewCreate, PerformanceReviewFilter>;
